<template>
  <div>
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <!-- メイン -->
    <!-- <v-main class="sub-back-image"> -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>
        <br/>
        <!-- 新規お申込みボタン -->
        <v-row>
          <v-col cols="7" class="d-flex align-end justify-start mt-4">
            <p class="text-h5">最新情報 [ {{searchStartDate}} ～ {{searchEndDate}} ] </p>
          </v-col>
          <v-col cols="5" class="d-flex justify-end mb-4" >
            <v-btn large color="orange darken-1 white--text" rounded  elevation="20" :loading="loading" @click="latest()">
              <v-icon>mdi-cached</v-icon>{{ $t("LMT001") }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- お申込み履歴エリア -->
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="datatableLoading" 
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 elevation-1"
          :no-data-text="$t('webmsg.mto100.datatblenodata')"
        >
          <template v-slot:[`item.regTyp`]="{ item }">
            <v-chip :class="getRegTypBtnColor(item.regTyp)" dark class="mr-4">
              {{ item.regTyp }}
            </v-chip>
          </template>

          <template v-slot:[`item.verifyStatus`]="{ item }">
            <template v-if="item.verifyStatus.name == '未確認'">
              <v-btn medium color="red" :disabled="item.unconfirmedInactive" class="white--text" min-width="80px" elevation="5" @click="requestVerify(item.requestNo, item.managerName, item.managerNameKana, item.mailAddress)">{{item.verifyStatus.name}}</v-btn>
            </template>
            <template v-else-if="item.verifyStatus.name != null && item.verifyStatus.name != ''">
              <v-chip outlined :color="item.verifyStatus.color" :text-color="item.verifyStatus.color" >
                <v-icon left>{{ item.verifyStatus.icon }}</v-icon>
                {{ item.verifyStatus.name }}
              </v-chip>
            </template>
          </template>

          <template v-slot:[`item.managerName`]="{ item }">
            {{ item.managerNameKana }}
            <br/>
            {{ item.managerName }}
          </template>
          <template v-slot:[`item.progress`]="{ item }">
            <v-chip :color="item.progress.color" text-color="white" v-if="item.progress.name != null && item.progress.name != ''">
              <v-icon left>{{ item.progress.icon }}</v-icon>
              {{ item.progress.name }}
            </v-chip>
          </template>

          <template v-slot:[`item.plan`]="{ item }">
            {{ item.basePlanName }}
            <span v-if="item.optionPlanName != null">
              <br/>
              {{ item.optionPlanName }}
            </span>
          </template>

          <template v-slot:[`item.company`]="{ item }">
            {{ item.company }}
            <br/>
            {{ item.name }}
          </template>
          <template v-slot:[`item.detail`]="{ item }">
              <v-btn medium color="indigo darken-1" dark min-width="80px" elevation="5" @click="dispConfirmView(item.requestNo, item.regTyp)">{{ $t("LCM005") }}</v-btn>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMainteVerifyRequest :msg="dlgVfReq.msg" :isOpen="dlgVfReq.isOpen" :requestNo="dlgVfReq.requestNo" :managerNameKana="dlgVfReq.managerNameKana" :managerName="dlgVfReq.managerName" :mailAddress="dlgVfReq.mailAddress" :doYes="dlgVfReq.doYes" :doNo="dlgVfReq.doNo"/>
  </div>
</template>

<script>
import Constants from '../common/constants';
import Utils from '../common/utils';
export default {
  name: "MainteManagerHome",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: " [メンテ] ホーム",
      screenId: "MTO100",
      messageArea: "",
      loading: false,
      searchStartDate: "",
      searchEndDate: "",
      progressKbnMstList: [],
      verifyStatusKbnMstList: [],
      datatableLoading: false,
      headers: [
          { text: '種類', align: 'center', sortable: true, value: 'regTyp', width: "8%"},
          { text: '番号', align: 'center', sortable: true, value: 'requestNo', width: "11%" },
          { text: '日付', align: 'center', sortable: true, value: 'requesdate', width: "11%" },
          { text: '本人確認', align: 'center', sortable: true, value: 'verifyStatus', width: "8%" },
          { text: '担当者名', align: 'start', sortable: true, value: 'managerName', width: "14%" },
          { text: '会社名・代表氏名', align: 'start', sortable: true, value: 'company', width: "14%" },
          { text: 'プラン', align: 'start', sortable: true, value: 'plan' },
          { text: '進捗', align: 'center', sortable: true, value: 'progress', width: "8%" },
          { text: '詳細', align: 'center', sortable: false, value: 'detail', width: "8%" },
          { text: 'メールアドレス', align: ' d-none', sortable: false, value: 'mailAddress', width: "5%" },
      ],
      desserts: [],
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },

      dlgVfReq: {
        msg: this.$i18n.t('msg.wrn.mb020'),
        isOpen: false,
        requestNo: "",
        managerNameKana: "",
        managerName: "",
        mailAddress:"",
        sex: "",
        birthDate: "",
        doYes: () => {
          // 本人確認依頼
          this.dlgVfReq.isOpen = false;
          // 最新化
          this.latest();
        },
        doNo: () => {
          this.dlgVfReq.isOpen = false;
        },
      },

    };
  },
  mounted() {
    // window.addEventListener('beforeunload', this.onLeave);
  },
  beforeDestroy() {
    // window.removeEventListener('beforeunload', this.onLeave);
  },
  created() {
    this.initialize();
  },
  methods: {
    /*
    * 未確認ボタン押下（本人確認依頼）
    */
    requestVerify: function(requestNo, name, nameKana, mailAddress) {
      this.dlgVfReq.requestNo = requestNo;
      this.dlgVfReq.managerName = name;
      this.dlgVfReq.managerNameKana = nameKana;
      this.dlgVfReq.mailAddress = mailAddress;
      this.dlgVfReq.isOpen = true;
    },
    /*
    * 初期表示
    */
    initialize: function() {
      this.messageArea = this.$i18n.t('webmsg.mto100.area');
      this.getRequestList();
    },

    /*
    * 最新ボタン押下
    */
    latest: function() {
      this.getRequestList();
    },

    /*
    * 申込履歴情報一覧取得
    */
    getRequestList : async function() {
      this.desserts = [];
      this.loading = true;
      this.datatableLoading = true;
      // ログインサービス呼び出し
      let responseData = null;
      let apiurl = Constants.URL_API_MTO100G01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data;
        this.setAuthUserInfo(responseData);
        this.displyRequestList(responseData);
        let result = this.setInitializeInfo(responseData);
        if (!result) {
          this.dlgMsg.msg = responseData.message;
          this.dlgMsg.isOpen = true;
        }
        this.dispProgress();
      } catch(error) {
         this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['申込み・問い合わせ一覧']);
         this.dlgMsg.isOpen = true;
         this.desserts.push({});
      } finally {
        this.loading = false;
        this.datatableLoading = false;
      }
    },

    /*
    * 申込一覧表示
    */
    displyRequestList : function(responseData) {
      this.desserts = new Array();
      if (responseData.data == null) {
        return;
      }
      this.searchStartDate =responseData.data.searchStartDate
      this.searchEndDate =responseData.data.searchEndDate
      let searchResultList = responseData.data.managerRequestList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      } 
      let request;
      for (const value of searchResultList) {
        request = {};

        request['requestNo'] = value.displayNo;
        if (value.displayNo.charAt(0) == "Q"){
          request['regTyp'] = "問合せ";
        } else {
          request['regTyp'] = "商登記";
        }
        let progress = {};
        progress['cd'] = value.latestProgressClass;
        progress['name'] = value.progressName;
        request['progress'] = progress;
        request['requesdate'] = value.displayDate; 
        request['company'] = value.companyName;
        request['name'] = value.name;
        request['managerName'] = value.managerName;
        request['managerNameKana'] = value.managerNameKana;
        request['basePlanName'] = value.displayBasePlanName;
        request['optionPlanName'] = value.displayOptionPlanName;         
        request['verifyStatus'] = {cd: value.verifyStatusClass, name: value.verifyStatusName};
        request['unconfirmedInactive'] = value.unconfirmedInactive;
        request['mailAddress'] = value.mailAddress;
        this.desserts.push(request);
      }
    },

    /*
    * マスタデータストア
    * データセット
    */
   setInitializeInfo: function(responseDto) {
      let retVal = false;
      if (responseDto == null) {
        return retVal;
      }
      let responseStatus = responseDto.statusCd;
      if (responseStatus !== 200) {
        return retVal;
      }
      retVal = true;
      // 区分マスタ（進捗区分）セット
      this.$store.dispatch("master/setProgressKbnList", responseDto.data.progressKbnList);
      // 区分マスタ（確認状態区分）セット
      this.$store.dispatch("master/setVerifyStatusKbnList", responseDto.data.verifyStatusKbnList);
      // 区分マスタ（処置結果区分）セット
      this.$store.dispatch("master/setDealResultKbnList", responseDto.data.dealResultKbnList);      

      return retVal;
   },
    
    /*
    * 進捗区分画面表示
    */
    dispProgress : function() {
      this.progressKbnMstList = this.$store.getters["master/getProgressKbnList"];
      this.verifyStatusKbnMstList = this.$store.getters["master/getVerifyStatusKbnList"];
      if (this.desserts == null || this.progressKbnMstList == null || this.verifyStatusKbnMstList == null) {
          return;
      }
      this.desserts.forEach((dessert, index, arr) => {
        if (dessert.progress.cd != null && dessert.progress.cd != '') {
          let progresData = this.getProgressNm(dessert.progress.cd);
          if (progresData != null) {
            arr[index].progress.name = progresData.nameAbbr;
            arr[index].progress.color = progresData.value2;
            arr[index].progress.icon = progresData.value3;
          }
        }
        if (dessert.verifyStatus.cd != null && dessert.verifyStatus.cd != '') {
          let verifyStatusData = this.getVerifyStatusNm(dessert.verifyStatus.cd);
          if (verifyStatusData != null) {
            arr[index].verifyStatus.name = verifyStatusData.nameAbbr;
            arr[index].verifyStatus.color = verifyStatusData.value2;
            arr[index].verifyStatus.icon = verifyStatusData.value3;
          }
        } else {
          if (dessert.regTyp == "商登記") {
            arr[index].verifyStatus.name = "未確認";
            // arr[index].verifyStatus.color = "red";
            // arr[index].verifyStatus.icon = "mdi-account-alert-outline";
          }
        }
      });

    },

     /**
     * 区分値（進捗）設定
     */
    getProgressNm(progressCd) {
      let retVal = "";
      let searchArry = "";
      if (progressCd != "") {
        searchArry = this.progressKbnMstList.find((v) => v.value1 === progressCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
    getVerifyStatusNm(verifyStatusCd) {
      let retVal = "";
      let searchArry = "";
      if (verifyStatusCd != "") {
        searchArry = this.verifyStatusKbnMstList.find((v) => v.value1 === verifyStatusCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
    /*
    * 種類画面表示(色変更)
    */
    getRegTypBtnColor(regTyp) {
      if (regTyp == "商登記") {
        return 'blue';
      } else {
        return 'green'
      }
    },

    /**
     * 詳細画面遷移
     */
    dispConfirmView(selectedRequestNo, regTyp) {

      let requestNo = Utils.removeChar(selectedRequestNo, '-');
      if (regTyp == "商登記") {
        this.$router.push(this.$router.resolve({ name: "MTR200", params: {requestNo: requestNo, srcScreenId: this.screenId} }).href);
      } else if (regTyp == "問合せ") {
        this.$router.push(this.$router.resolve({ name: "MTQ200", params: {inquiryNo: requestNo, srcScreenId: this.screenId} }).href);
      }
    },
    /*
    * 認証情報設定
    */
    setAuthUserInfo : function(responseData) {
      let loginUserInfo = responseData.data.loginUserInfo;
      this.$store.dispatch("authcUser/setLoggedUserInfo", {id: loginUserInfo.id, name:loginUserInfo.name, deptname:loginUserInfo.deptname});
      this.username = loginUserInfo.name;
      this.deptname = loginUserInfo.deptname;
    },
  },
};
</script>

<style scoped>
.under {
  background: linear-gradient(transparent 70%, #ff99ab 70%);
}
</style>
